(function(){
    angular
        .module('appback')
        .directive('ngTodecimalalt', ngTodecimalalt);

        ngTodecimalalt.$inject = ['$timeout'];
        function ngTodecimalalt($timeout){
            return {
	            require: 'ngModel',
	            scope: {
	            	numdecimales:'='
	            },
	            link: function(scope, element, attrs, ngModel) {
					var ctrlDown = false;
					var ctrlKey = 17, vKey = 86, cKey = 67, aKey = 65, xKey = 88;
					
					element.on('keydown', function (event) {  
						var $input = $(this);  
						var value = $input.val();  
						value = value.replace(/[^0-9,.-]/g, '');  // Permitimos el guión para números negativos
						$input.val(value);
						
						// Comprobamos si Ctrl está presionado
						if (event.which == ctrlKey) ctrlDown = true;
						
						if (ctrlDown && [vKey, cKey, aKey, xKey].indexOf(event.which) > -1) {
							// Permitir Ctrl+V, Ctrl+C, Ctrl+A, Ctrl+X
							return true;
						} else if (event.which == 64 || event.which == 16) {  
							// to allow numbers  
							return false;  
						} else if (event.which >= 48 && event.which <= 57) {  
							// to allow numbers  
							return true;  
						} else if (event.which >= 96 && event.which <= 105) {  
							// to allow numpad number  
							return true;  
						} else if ([8, 13, 27, 37, 38, 39, 40, 9, 17, 189, 109].indexOf(event.which) > -1) {  
							// to allow backspace, enter, escape, arrows, tab, and minus sign (both regular and numpad)
							return true;  
						} else if ([188, 190, 110, 194].indexOf(event.which) > -1) {  
							// to allow comma, period, numpad dot, and Spanish decimal separator
							return true;  
						} else {  
							event.preventDefault();  
							return false;  
						}  
					});

					element.on('keyup', function (event) {
						// Comprobamos si Ctrl ha sido liberado
						if (event.which == ctrlKey) ctrlDown = false;
					});

					ngModel.$parsers.push(function (inputValue) {
						if (inputValue == null)
							return ''
						var valor = inputValue.replace(',', '.');
						ngModel.$setViewValue(valor);
						ngModel.$render();
						return valor;
					});

					/*ngModel.$formatters.push(function(value) {
						console.log("tocecimal2");
						return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
					});*/
				}
			}
        }
})();